module.exports = __webpack_public_path__ + "static/media/visits.d3c39957.svg";